export const getSafeRedirectPath = (
  rawPath: string | null | undefined,
  fallback = "/home"
): string => {
  if (!rawPath) return fallback;
  if (!rawPath.startsWith("/")) return fallback;
  if (rawPath.startsWith("//")) return fallback;
  return rawPath;
};
